import { createI18n } from 'vue-i18n'
import tr from './tr.json'
import az from './az.json'
import en from './en.json'
import ru from './ru.json'
import de from './de.json'
import ar from './ar.json'

const instance = createI18n({
  legacy: false,
  locale: localStorage.getItem('lang') || 'tr',
  fallbackLocale: 'tr',
  messages: { tr, az, en, ru, de, ar }
})

export default instance

export const i18n = instance.global
